import Vue from 'vue'
import Router from 'vue-router'
import loginAccess from '@/components/access/login'
import recoveryAccess from '@/components/access/recovery'
import resetAccess from '@/components/access/reset'

import Home from '@/components/home'

import UserList from '@/components/users/list'
import UserEdit from '@/components/users/edit'

import CustomerList from '@/components/customers/list'
import CustomerEdit from '@/components/customers/edit'

import PostCategoryList from '@/components/post_categories/list'
import PostCategoryEdit from '@/components/post_categories/edit'

import PostList from '@/components/posts/list'
import PostEdit from '@/components/posts/edit'

import PageList from '@/components/pages/list'
import PageEdit from '@/components/pages/edit'

import PortfolioList from '@/components/portfolio/list'
import SectorList from '@/components/sectors/list'

import GalleryList from '@/components/galleries/list'
import GalleryEdit from '@/components/galleries/edit'

import GalleryImageList from '@/components/galleries/image.list'
import GalleryImageEdit from '@/components/galleries/image.edit'

import GalleryTypeList from '@/components/galleries/type.list'
import GalleryTypeEdit from '@/components/galleries/type.edit'

import ProductList from '@/components/products/list'
import ProductEdit from '@/components/products/edit'

import AttributeList from '@/components/products/attributes/list'
import AttributeEdit from '@/components/products/attributes/edit'

import AttributeTypeList from '@/components/products/attributes/type.list'
import AttributeTypeEdit from '@/components/products/attributes/type.edit'

import ImageMedia from '@/components/media/viewer'
import CKViewer from '@/components/media/ckeditor.browser'

import { auth } from '@/assets/js/libs/sessions'

Vue.use(Router)

const router = new Router({
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/usuarios/nuevo',
			name: 'userNew',
			component: UserEdit,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/usuarios/:page',
			name: 'userList',
			component: UserList,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/usuarios/editar/:id',
			name: 'userEdit',
			component: UserEdit,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/usuarios',
			redirect: '/usuarios/1'
		},
		{
			path: '/clientes/nuevo',
			name: 'customerNew',
			component: CustomerEdit,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/clientes/:page',
			name: 'customerList',
			component: CustomerList,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/clientes/editar/:id',
			name: 'customerEdit',
			component: CustomerEdit,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/clientes',
			redirect: '/clientes/1'
		},
		{
			path: '/categorias-de-entradas/nuevo',
			name: 'postCategoryNew',
			component: PostCategoryEdit,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/categorias-de-entradas/:page',
			name: 'postCategoryList',
			component: PostCategoryList,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/categorias-de-entradas/editar/:id',
			name: 'postCategoryEdit',
			component: PostCategoryEdit,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/categorias-de-entradas',
			redirect: '/categorias-de-entradas/1'
		},
		{
			path: '/entradas/nuevo',
			name: 'postNew',
			component: PostEdit,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/entradas/:page',
			name: 'postList',
			component: PostList,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/entradas/editar/:id',
			name: 'postEdit',
			component: PostEdit,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/entradas',
			redirect: '/entradas/1'
		},
		{
			path: '/paginas/nuevo',
			name: 'pageNew',
			component: PageEdit,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/paginas/:page',
			name: 'pageList',
			component: PageList,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/paginas/editar/:id',
			name: 'pageEdit',
			component: PageEdit,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/paginas',
			redirect: '/paginas/1'
		},
		{
			path: '/portafolio',
			name: 'portfolioList',
			component: PortfolioList,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/sectores',
			name: 'sectorList',
			component: SectorList,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/acceso/login',
			name: 'login',
			component: loginAccess,
			meta: {
				auth: false,
				roles: null
			}
		},
		{
			path: '/acceso/recuperar-contrasena',
			name: 'recovery',
			component: recoveryAccess,
			meta: {
				auth: false,
				roles: null
			}
		},
		{
			path: '/acceso/cambiar-contrasena',
			name: 'reset',
			component: resetAccess,
			meta: {
				auth: false,
				roles: null
			}
		},
		{
			path: '/galerias/nueva',
			name: 'galleryNew',
			component: GalleryEdit,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/galerias/editar/:id',
			name: 'galleryEdit',
			component: GalleryEdit,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/galerias/tipos/nueva',
			name: 'galleryTypeNew',
			component: GalleryTypeEdit,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/galerias/tipos/editar/:id',
			name: 'galleryTypeEdit',
			component: GalleryTypeEdit,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/galerias/tipos/:page',
			name: 'galleryTypeList',
			component: GalleryTypeList,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/galerias/imagenes/nueva/:gallery_id',
			name: 'galleryImageNew',
			component: GalleryImageEdit,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/galerias/imagenes/editar/:gallery_id/:id',
			name: 'galleryImageEdit',
			component: GalleryImageEdit,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/galerias/imagenes/:gallery_id/:page',
			name: 'galleryImageList',
			component: GalleryImageList,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/galerias/:page',
			name: 'galleryList',
			component: GalleryList,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/galerias',
			redirect: '/galerias/1'
		},
		{
			path: '/productos/nuevo',
			name: 'productNew',
			component: ProductEdit,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/productos/editar/:id',
			name: 'productEdit',
			component: ProductEdit,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/productos/:page',
			name: 'productList',
			component: ProductList,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/productos',
			redirect: '/productos/1'
		},
		{
			path: '/atributos/tipos/nuevo',
			name: 'attributeTypeNew',
			component: AttributeTypeEdit,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/atributos/tipos/editar/:id',
			name: 'attributeTypeEdit',
			component: AttributeTypeEdit,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/attributos/tipos/:page',
			name: 'attributeTypeList',
			component: AttributeTypeList,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/atributos/tipos',
			redirect: '/attributos/tipos/1'
		},
		{
			path: '/atributos/nuevo',
			name: 'attributeNew',
			component: AttributeEdit,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/atributos/editar/:id',
			name: 'attributeEdit',
			component: AttributeEdit,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/atributos/:page',
			name: 'attributeList',
			component: AttributeList,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/atributos',
			redirect: '/atributos/1'
		},
		{
			path: '/media',
			name: 'media',
			component: ImageMedia,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/ckeditor-browser/*',
			name: 'ckViewer',
			component: CKViewer,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		}
	],
	scrollBehavior(to, from, savedPosition) {
		return { x: 0, y: 0 }
	}
})

router.beforeEach((to, from, next) => {
	auth.loggedIn(to, from).then(isAuth => {
		if (!isAuth.auth && isAuth.route === 'login') {
			auth.logout()
			next({ name: 'login' })
		} else if (isAuth.auth && isAuth.route === 'home') {
			next({ name: 'home' })
		} else if (to.name === null || to.name === undefined) {
			next({ name: 'home' })
		} else {
			next()
		}
	})
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js